function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuvetteRackFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "270px",
    height: "41px",
    viewBox: "0 16 272 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.527344 0 L 272 0 L 227.472656 23.429688 L 0 23.429688 Z M 44.527344 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60%,60%,60%)",
      fillOpacity: 1
    },
    d: "M 206.238281 5.855469 L 239.828125 5.855469 L 220.632812 16.105469 L 188.644531 16.105469 Z M 206.238281 5.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60%,60%,60%)",
      fillOpacity: 1
    },
    d: "M 103.875 5.855469 L 137.460938 5.855469 L 118.269531 16.105469 L 86.28125 16.105469 Z M 103.875 5.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60%,60%,60%)",
      fillOpacity: 1
    },
    d: "M 52.691406 5.855469 L 86.28125 5.855469 L 67.085938 16.105469 L 35.097656 16.105469 Z M 52.691406 5.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60%,60%,60%)",
      fillOpacity: 1
    },
    d: "M 155.054688 5.855469 L 188.644531 5.855469 L 169.453125 16.105469 L 137.460938 16.105469 Z M 155.054688 5.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,93.333333%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 0 23.429688 L 228.128906 23.429688 L 228.128906 41 L 0 41 Z M 0 23.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,93.333333%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 227.398438 23.429688 L 271.777344 0 L 271.777344 32.214844 L 227.398438 41 Z M 227.398438 23.429688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuvetteRackFront);
export default __webpack_public_path__ + "static/media/cuvette-rack-front.401d037f3dcab5123c78b15398054b2f.svg";
export { ForwardRef as ReactComponent };